module.exports = __webpack_public_path__ + "img/logo.d3a04784.png";